<div #mapEl aria-label="Mapa que muestra la ubicación" [style.height]="height" style="width: 100%;"></div>